var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8610_254204)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_8610_254204)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8610_254204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6865 41.6902C42.0509 39.3256 45.7731 39.1076 48.2483 41.1886L50.0367 42.6952C52.0777 44.4129 52.2853 47.5092 50.4968 49.6092C49.5215 50.7376 48.1486 51.4464 46.6639 51.5881C40.9491 52.3579 34.9541 49.604 28.6755 43.3249C22.3969 37.0457 19.6415 31.0485 20.4112 25.335C20.4512 24.888 20.5441 24.4472 20.688 24.0221C21.0208 23.0454 21.6084 22.1754 22.3899 21.5018C24.4915 19.7149 27.5858 19.9207 29.3034 21.9636L30.8082 23.7522C32.8924 26.2241 32.6762 29.9484 30.3118 32.313L29.0283 33.5948C28.6862 33.9376 28.5741 34.4479 28.7412 34.9025C29.2082 36.1791 30.4 37.774 32.313 39.6871C34.2277 41.602 35.8224 42.7921 37.0972 43.2609C37.5521 43.4275 38.0624 43.3148 38.4048 42.972L39.6865 41.6902Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8610_254204",
    x1: 0,
    y1: 0,
    x2: 72,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99CC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8610_254204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8610_254204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.66a22639.svg";
export { ForwardRef as ReactComponent };